import { Authenticated, useOne, useTranslate } from "@refinedev/core";
import { useParams } from "react-router-dom";
import { Typography } from "antd";
import { AlertCard, Spinner } from "@libertify/ui";
import { SubPageHeader } from "../../../components/SubPageHeader";
import { StudioTopBar } from "components/layout/header/StudioTopBar";
import { MediaProjectResponse } from "../types";
import { ProjectChatHistoryCard } from "./components/ProjectChatHistory";
import { useHistoryBack } from "./hooks/useHistoryBack";

export const ProjectChatHistoryPage = () => {
  const t = useTranslate();
  const { id } = useParams<{ id: string }>();
  const handleBack = useHistoryBack();

  const { data, isLoading, isError } = useOne<MediaProjectResponse>({
    resource: `media/projects`,
    id,
  });
  const project = data?.data;

  return (
    <Authenticated key="project_chat_history">
      <SubPageHeader
        itemId={project?.id}
        itemTitle={project?.title ?? ""}
        page="chat"
        source="projects"
        onBack={handleBack}
        rightContent={<StudioTopBar />}
      />
      <Typography.Title>
        {t("projects.components.ProjectFeature.chat")}
      </Typography.Title>

      {isLoading ? <Spinner /> : null}
      {isError ? (
        <AlertCard
          type="error"
          title={t("projects.components.ProjectFeature.loadError")}
        />
      ) : null}
      {project ? (
        <ProjectChatHistoryCard
          projectId={project.id}
          projectCreated={project.created}
        />
      ) : null}
    </Authenticated>
  );
};
